module.exports = __webpack_public_path__ + "static/CVS-CATCH-DLB-HS-Inhaling-Flavor-Ed-Guide-bcbc5068cd252f595af2ec9b8c37bd31.pdf";